import React from "react";
import PropTypes from "prop-types";

const PhoneLink = ({ label, link }) => (
  <a className='phone-link-web-sdk' href={`tel:${link}`}>
    {label}
  </a>
);

PhoneLink.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default PhoneLink;
